import React from 'react';
import { RFFormInput, RFFormCheckbox, InfoRow } from 'virtues-bootstrap';
import { Trans, withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';

import { ReactComponent as DangerIcon } from 'svg/exclamation-circle-solid.svg';
import { ReactComponent as BatteryIcon } from 'svg/battery-three-quarters-solid.svg';

import { NOT_APPLICABLE } from 'constants/common';

import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';

import ShocksFieldArray from './ShocksFieldArray';

import s from '../styles.module.scss';

const titleSizesLongevity = {
  xs: 4,
  lg: 3,
};

const contentSizesLongevity = {
  xs: 8,
  lg: 6,
};

const contentSizesDeviceParams = {
  md: 12,
  lg: 9,
};

const titleSizesDeviceParams = {
  xs: 12,
  md: 12,
  sm: 12,
  lg: 3,
};

const DeviceInformationForm = ({ t, alert, shockNa, onChangeShockCheckbox }) => (
  <>
    {alert && (
      <InfoRow
        title={t('reports.alertInfoLabel')}
        className={s.dangerRow}
        icon={<DangerIcon className={s.dangerIcon} />}
      />
    )}
    <AdaptiveDataRow
      withLabelMargin
      titleSizes={titleSizesLongevity}
      contentSizes={contentSizesLongevity}
      title={t('reports.isContainsAlert')}
    >
      <Field component={RFFormCheckbox} name="alert" />
    </AdaptiveDataRow>

    <AdaptiveDataRow
      withLabelMargin
      iconClassName={s.icon}
      titleSizes={titleSizesLongevity}
      contentSizes={contentSizesLongevity}
      title={t('reports.longevity')}
      icon={<BatteryIcon />}
    >
      <Field
        className={s.fieldWithoutMargin}
        component={props => {
          const {
            // eslint-disable-next-line react/prop-types
            input: { value },
          } = props;
          const regex = /end of life/i;
          const isEOL = regex.test(value);

          return (
            <RFFormInput
              {...props}
              style={{
                borderStyle: isEOL && 'dashed',
                borderColor: isEOL && '#ffef00bd',
                borderWidth: isEOL && '0.2em',
              }}
            />
          );
        }}
        name="batteryLife"
      />
    </AdaptiveDataRow>

    <FieldArray name="shocksDate" component={ShocksFieldArray} />

    <AdaptiveDataRow
      withLabelMargin
      titleSizes={titleSizesDeviceParams}
      contentSizes={contentSizesDeviceParams}
      title={t('reports.deviceParameters')}
    >
      <div className={s.deviceParam}>
        <Trans i18nKey="reports.pacingSettings">
          Pacing settings: if heart rate drops below
          <Field className={s.fieldBpm} component={RFFormInput} name="pacing" />
          bpm
        </Trans>
      </div>
      <div className={s.deviceParam}>
        <Trans i18nKey="reports.shockSettings">
          Shock settings: if heart rate goes above
          <div className={s.shockValues}>
            <Field
              component={RFFormCheckbox}
              label={NOT_APPLICABLE}
              name="shockNa"
              onChange={onChangeShockCheckbox}
            />
            <Field disabled={shockNa} className={s.fieldBpm} component={RFFormInput} name="shock" />
          </div>
          bpm
        </Trans>
      </div>
    </AdaptiveDataRow>
  </>
);

DeviceInformationForm.propTypes = {
  t: PropTypes.func.isRequired,
  alert: PropTypes.bool,
  shockNa: PropTypes.bool.isRequired,
  onChangeShockCheckbox: PropTypes.func.isRequired,
};

DeviceInformationForm.defaultProps = {
  alert: false,
};

export default withTranslation()(DeviceInformationForm);
